import React, { useEffect } from 'react';
import { Flex, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import { Config } from '@leverege/plugin';
import S from './Pair.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LocatorOffline() {
  const {
    setNextText,
    setBackText,
    setHeader,
    setHeaderIcon
  } = useWizard();
  useEffect(() => {
    // Set the header title and icon using the wizard context
    setHeader('Pair Equipment to Locator');
    setHeaderIcon('fak fa-lv-pair');
    setNextText('Select Another Locator');
    setBackText('Cancel');
    return () => {
      setNextText(null);
      setBackText(null);
      setHeader(null);
      setHeaderIcon(null);
    };
  }, [setNextText, setBackText, setHeader, setHeaderIcon]);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "colL",
    children: [/*#__PURE__*/_jsx("img", {
      className: S.locatorError,
      src: "https://recovr-ui-assets.storage.googleapis.com/locator-error.png",
      alt: "Locator warning",
      height: 136,
      width: 136
    }), /*#__PURE__*/_jsx(Text, {
      variant: "formTitle",
      children: "Locator Offline"
    }), /*#__PURE__*/_jsx(Text, {
      "data-cy": Config.get('cypress', ['text', 'locator.offline'], 'text.locator.offline'),
      children: "This Locator is offline and cannot be paired to an asset. Please select a new Locator to pair."
    })]
  });
}

// Add the TYPE property for registration
LocatorOffline.TYPE = 'recovr.LocatorOffline';